import type { App } from 'vue'
import vueCountryRegionSelect from 'vue3-country-region-select'

export default function (app: App) {
  app.use(vueCountryRegionSelect)
}
